import {
  FETCH_AGREEMENTS_PENDING,
  FETCH_AGREEMENTS_FULFILLED,
  FETCH_AGREEMENTS_REJECTED,
  FETCH_INITIATE_REGISTER_PENDING,
  FETCH_INITIATE_REGISTER_FULFILLED,
  FETCH_INITIATE_REGISTER_REJECTED,
  FETCH_COMPLETE_REGISTER_PENDING,
  FETCH_COMPLETE_REGISTER_FULFILLED,
  FETCH_COMPLETE_REGISTER_REJECTED,
  RESET_REGISTER,
} from "../../actions/auth/genesis";

const initialState = {
    agreements: [], // Sözleşmeler
    initiateData: null, // Kayıt başlatma yanıtı
    completeData: null, // Kayıt tamamlama yanıtı
    done: false,
    hasError: false, // Hata kontrol durumu
    error: false,
    responseMessage: null, // Hata veya bilgilendirme mesajı
    responseCode: null, // Yanıt kodu
    spinner: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        /** Sözleşme Alma */
        case FETCH_AGREEMENTS_PENDING:
            return {
                ...state,
                spinner: true,
                error: false,
                hasError: false,
                responseMessage: null,
                responseCode: null,
                done: false,
            };
        case FETCH_AGREEMENTS_FULFILLED:
            return {
                ...state,
                agreements: action.payload.result,
                spinner: false,
                error: false,
                hasError: false,
                responseMessage: null,
                responseCode: null,
                done: true,
            };
        case FETCH_AGREEMENTS_REJECTED:
            return {
                ...state,
                spinner: false,
                error: true,
                hasError: true,
                responseMessage: action.payload.responseMessage || "Sözleşmeler alınamadı.",
                responseCode: action.payload.responseCode || null,
                done: false,
            };

        /** Kayıt Başlatma */
        case FETCH_INITIATE_REGISTER_PENDING:
            return {
                ...state,
                spinner: true,
                error: false,
                hasError: false,
                responseMessage: null,
                responseCode: null,
                done: false,
            };
        case FETCH_INITIATE_REGISTER_FULFILLED:
            return {
                ...state,
                initiateData: action.payload,
                spinner: false,
                error: false,
                hasError: false,
                responseMessage: null,
                responseCode: null,
                done: true,
            };
        case FETCH_INITIATE_REGISTER_REJECTED:
            return {
                ...state,
                spinner: false,
                error: true,
                hasError: true,
                responseMessage: action.payload.responseMessage || "Kayıt başlatma işlemi başarısız oldu.",
                responseCode: action.payload.responseCode || null,
                done: false,
            };

        /** Kayıt Tamamlama */
        case FETCH_COMPLETE_REGISTER_PENDING:
            return {
                ...state,
                spinner: true,
                error: false,
                hasError: false,
                responseMessage: null,
                responseCode: null,
                done: false,
            };
        case FETCH_COMPLETE_REGISTER_FULFILLED:
            return {
                ...state,
                completeData: action.payload,
                spinner: false,
                error: false,
                hasError: false,
                responseMessage: null,
                responseCode: null,
                done: true,
            };
        case FETCH_COMPLETE_REGISTER_REJECTED:
            return {
                ...state,
                spinner: false,
                error: true,
                hasError: true,
                responseMessage: action.payload.responseMessage || "Kayıt tamamlama işlemi başarısız oldu.",
                responseCode: action.payload.responseCode || null,
                done: false,
            };

        /** Reset */
        case RESET_REGISTER:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};


